import script from "./GameCard.vue?vue&type=script&setup=true&lang=js"
export * from "./GameCard.vue?vue&type=script&setup=true&lang=js"

import "./GameCard.vue?vue&type=style&index=0&id=3d1995a9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d1995a9"]])

export default __exports__